import React from 'react';
export function TruthSection() {
  return <section className="w-full bg-cream py-16 md:py-24 px-4" data-id="element-168">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-169">
        <div className="order-2 md:order-1 relative" data-id="element-170">
          <img src="https://cdn.magicpatterns.com/uploads/24gLYDg2gNWLQsLB3V3Bzg/mockup-2.png" alt="Espejo y productos de skincare" className="w-full rounded-lg shadow-xl" data-id="element-171" />
          <div className="absolute -bottom-6 -right-6 bg-white p-6 shadow-lg max-w-xs hidden md:block" data-id="element-172">
            <p className="font-serif italic text-2xl text-brown-primary" data-id="element-173">
              "Lujo de Farmacia"
            </p>
          </div>
        </div>

        <div className="order-1 md:order-2" data-id="element-174">
          <h2 className="text-3xl md:text-4xl font-bold text-brown-primary mb-6" data-id="element-175">
            La Verdad que las marcas no quieren que sepas
          </h2>

          <div className="space-y-6 text-lg text-brown-secondary" data-id="element-176">
            <p data-id="element-177">
              Aquí está el secreto que las marcas de lujo no quieren que sepas:{' '}
              <strong className="text-brown-primary" data-id="element-178">
                Tu piel no necesita el logo de la marca.
              </strong>{' '}
              Necesita el activo correcto en el orden correcto.
            </p>

            <p data-id="element-179">
              En México tenemos acceso a productos genéricos y de farmacia con
              la misma calidad (o mejor) que las marcas francesas, pero a una
              fracción del costo.
            </p>

            <p className="text-xl font-serif italic text-rose-gold" data-id="element-180">
              Solo te falta el MAPA para encontrarlos y el CICLO para usarlos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}